<template>

  <div class="passing-search-list">
    <div class="passing-search-direction">
      <el-radio-group v-model="query.direction" @input="getDirectioData">

        <el-radio-button label="">双向查询</el-radio-button>
        <el-radio-button label="3">到达查询</el-radio-button>
        <el-radio-button label="4">发出查询</el-radio-button>
        <!--        <el-radio-button :label="item.dictValue"  v-for="item in directionDict" >{{item.dictLabel}}</el-radio-button>-->
      </el-radio-group>
    </div>
    <avue-crud ref="crud" :option="option" :data="data" :table-loading="loading" :search.sync="query"
      :row-class-name="listRowClassName" @search-change="handleSearch" @search-reset="handleReset"
      @row-dblclick="handleListDBClick">
      <template slot="searchMenu" slot-scope="{row,size}">
        <el-button v-has-permi="[`${permiStr}:train:import`]" type="primary" icon="el-icon-folder-opened" :size="size"
          @click="handleImport">导入
        </el-button>
        <el-button v-has-permi="[`${permiStr}:train:add`]" type="primary" icon="el-icon-edit-outline" :size="size"
          @click="handleAdd">录入
        </el-button>
      </template>
      <template #customMenu="{ row }">
        <i v-if="!row.isArtificialAdd" class="el-icon-delete table-del-btn--disabled"></i>
        <i v-else class="el-icon-delete table-del-btn" @click="handleListDel(row)"></i>
      </template>
    </avue-crud>
    <train-import ref="import" :is-h-g-z="isHGZ" @afterImport="handleRefresh"></train-import>

    <dialog-reset slotShow height="65vh" width="1150px" top="10vh" title="异常数据" :visible.sync="errorShow">
      <avue-crud ref="errorcrud" :option="erroroption" :data="errorData" :row-class-name="listRowClassName">
        <template slot="customMenu" slot-scope="{row,size}">
          <el-button type="text" @click="openReport(row)">检车报告</el-button>
        </template>
      </avue-crud>
    </dialog-reset>
  </div>
</template>

<script>

import { getDate } from "@/util/date";
import { getNewPassingData, getTrainListData, trainListDelete, orderOcrContainerDiffAlarm } from "@/api/handover-inspection/passing-manage";
import TrainImport from "./train-import.vue";
import moment from "moment";

export default {
  name: "passing-search-list",
  components: { TrainImport },
  props: ['permiStr', 'isHGZ'],
  data() {
    return {
      loading: false,
      addCarriageVisible: false, // 新增车次/车厢 visible
      option: {
        height: '',
        selection: false,
        index: false,
        tip: false,
        border: true,
        header: false,
        menu: false,
        align: 'center',
        searchMenuSpan: 24,
        searchMenuPosition: 'right',
        searchSpan: 12,
        searchLabelWidth: 50,
        labelSuffix: ':', // label的后缀，这里是个空格，不是空字符串
        searchLabelPosition: 'top',
        column: [
          {
            label: "过车时间",
            prop: "comeTime",
            width: 135,
          },
          {
            label: "节数",
            prop: "totalCars",
            minWidth: 48,
          },
          {
            label: "方向",
            prop: "direction",
            minWidth: 50,
            search: false,
            type: 'select',
            filterable:true,
            dicUrl: `${this.baseDicUrl}/direction`,
            props: this.dicProps
          },
          {
            label: "车号",
            prop: "trainNo",
            hide: true,
            search: false,
          },
          {
            label: "采点位置",
            searchLabel: '股道',
            prop: "poundno",
            minWidth: 80,
            search: true,
            type: 'select',
            dicUrl: `${this.baseDicUrl}/${this.isHGZ ? 'hgz_poundno_code' : 'jtg_poundno_code'}`,
            props: this.dicProps,
            filterable: true,
            clearable: false,
            searchOrder: 5,
            searchSpan: 24,
            searchLabelWidth: 80,
            popperClass: 'passing-search-select-popper',
          },
          {
            label: "开始时间",
            prop: "comeTimeStart",
            type: "datetime",
            width: 200,
            hide: true,
            search: true,
            searchSpan: 24,
            searchLabelWidth: 80,
            format: "yyyy-MM-dd HH:mm:ss",
            valueFormat: "yyyy-MM-dd HH:mm:ss",
            popperClass: 'passing-search-time-popper',
            blur: () => {
              this.handleSearch()
            }
          },
          {
            label: "结束时间",
            prop: "comeTimeEnd",
            type: "datetime",
            hide: true,
            search: true,
            searchSpan: 24,
            searchLabelWidth: 80,
            format: "yyyy-MM-dd HH:mm:ss",
            valueFormat: "yyyy-MM-dd HH:mm:ss",
            popperClass: 'passing-search-time-popper',
            blur: () => {
              this.handleSearch()
            }
          },
          // {
          //   label: "时间",
          //   prop: "searchDate",
          //   type: "datetime",
          //   hide: true,
          //   search: true,
          //   searchSpan: 24,
          //   searchRange: true,
          //   clearable: false,
          //   format: "yyyy-MM-dd HH:mm:ss",
          //   valueFormat: "yyyy-MM-dd HH:mm:ss",
          //   defaultTime: ['00:00:00', '23:59:59'],
          // },
          {
            label: "操作",
            prop: "customMenu",
            width: 62
          }
        ]
      },
      data: [],
      query: {},
      defaultParams: {
        poundno: this.isHGZ ? '001' : '002,003',
        comeTimeStart: getDate('dayS'),
        comeTimeEnd: getDate('dayE'),
        // searchDate: [getDate('dayS'), getDate('dayE')]
      },
      selectedRowId: '', // 选中行 id
      waitTime: '', // 新车提示按钮读秒时间
      getNewTimer: null,
      newTrainVisible: false, // 新车提示弹窗是否打开
      oldPassingTime: '', // 记录getNewPassingData接口返回时间用于判断是否是新车数据

      erroroption: {
        border: true,
        header: false,
        addBtn: false,
        editBtn: false,
        viewBtn: false,
        delBtn: false,
        index: false,
        menu: false,
        selection: false,

        column: [
          {
            label: "方向",
            prop: "direction",
            minWidth: 50,
            type: 'select',
            filterable:true,
            dicUrl: `${this.baseDicUrl}/direction`,
            props: this.dicProps
          },
          {
            label: "股道",
            prop: "poundno",
            type: 'select',
            filterable:true,
            dicUrl: `${this.baseDicUrl}/${this.isHGZ ? 'hgz_poundno_code' : 'jtg_poundno_code'}`,
            props: this.dicProps
          },
          {
            label: "车节数",
            prop: "totalCars",
          },
          {
            label: "过车时间",
            prop: "comeTime",
            width: 135,
          },
          {
            label: "操作",
            prop: "customMenu",
            width: 135
          }
        ]
      },
      errorData: [],
      errorShow: false,
    }
  },
  created() {
    // 列表高度
    const pageH = document.documentElement.clientHeight;
    // this.option.height = ~~(pageH * 0.5 - 200).toString()
    this.option.height = ~~(pageH - 375 - 60).toString()
  },
  mounted() {
    this.handleReset()
    // this.getNewTrain()
    this.$set(this.query, 'direction', '');
  },
  methods: {
    getDirectioData(e) {
      this.query.direction = e
      this.handleSearch()
    },
    handleSearch(params, done, successCb) {
      const searchParams = this.deepClone(this.query)
      const { comeTimeStart, comeTimeEnd } = searchParams
      const interval = moment(comeTimeEnd).diff(comeTimeStart, 'month')
      if (interval > 6) {
        this.$message.error('时间跨度不能超过6个月')
        if (done) done()
        return
      }
      this.loading = true
      getTrainListData(searchParams).then(res => {
        if (res.code === 200) {
          this.data = res.data
          if (successCb) successCb(res.data)
          // 未选中时查询全部数据异常统计信息
          if (!this.selectedRowId) {
            this.$bus.emit('searchErrStatistics', this.deepClone(this.query))
          }
        }
      }).finally(() => {
        this.loading = false
      })

      if (this.query.direction != 4) {
        let diffTime = localStorage.getItem('diffTime')
        console.log(diffTime)
        if (this.isNull(diffTime)) {
          this.orderOcrContainerDiffAlarm(searchParams)
        } else {
          // 
          if (new Date().getTime() - diffTime > 1000* 60 * 60 * 1) {
            this.orderOcrContainerDiffAlarm(searchParams)
          }
        }
      }


      if (done) done()
    },
    handleRefresh() {
      this.handleSearch(this.query)
    },
    handleReset() {
      this.query = this.deepClone(this.defaultParams)
      this.handleRefresh()
    },
    orderOcrContainerDiffAlarm(searchParams) {
      this.errorShow = false

      orderOcrContainerDiffAlarm({
        poundNo: searchParams.poundno,
        startTime: searchParams.comeTimeStart,
        endTime: searchParams.comeTimeEnd
      }).then(res => {
        if (res.code == 200) {
          this.errorData = res.data
          if (res.data.length > 0) {
            this.errorShow = true
            localStorage.setItem('diffTime', new Date().getTime())
          }
        }
      })
    },
    openReport(row) {
      let data = this.data.find(item => item.id === row.trainListId)
      if (this.isNull(data)) {
        return
      }
      this.$emit('handle-select', data, true)
    },

    // 导入车次
    handleImport() {
      this.$refs.import.visible = true
    },
    // 录入车次
    handleAdd() {
      this.$emit('handleAdd')
    },
    listRowClassName({ row, rowIndex }) {
      row.idx = rowIndex
      // checkFlag 是否已预检 0否 1正在预检
      const { id, checkFlag, exceNum } = row
      const isErr = checkFlag !== 1 && exceNum >= 1
      // 文字颜色
      const color = isErr ? 'error-row' : checkFlag === 1 ? 'success-row' : ''
      // 背景颜色 
      let bgColor = ''
      // if (id === this.selectedRowId) {
      //   const warning = isErr ? '--warning' : ''
      //   bgColor = `row-selected${warning}`
      // }
      const warning = isErr ? 'row-selected--warning' : ''
      const check = checkFlag === 1 ? 'lvs' : ''
      return [warning, check, 'triangle-box']
    },
    // 选择车次
    handleListDBClick(row) {
      this.selectedRowId = row.id
      this.$emit('handle-select', row, false)
      this.handleDomChange(row.$index)
    },
    // 删除
    handleListDel(row) {
      this.$modal.confirm('确定删除选中信息？').then(() => {
        this.loading = true
        trainListDelete({ trainListId: row.id }).then(res => {
          if (res.code === 200) {
            this.$message.success('操作成功')
            this.handleSearch(this.query)
          } else {
            this.loading = false
          }
        }).catch(() => {
          this.loading = false
        })
      })
    },
    // 跳转至最新车辆
    goToNewTrain() {
      this.query = { searchDate: [getDate('dayS'), getDate('dayE')] }
      // 查询当天数据并选中第一条
      this.handleSearch(this.query, null, (data) => {
        this.handleListDBClick(data[0])
      })
    },
    // 查询是否有新车
    getNewTrain() {
      this.getNewTimer = setInterval(() => {
        if (!this.newTrainVisible) {
          getNewPassingData().then(res => {
            if (res.code === 200) {
              const { newPassingTime } = res.data
              if (this.oldPassingTime && this.oldPassingTime !== newPassingTime) {
                this.newTrainConfirm()
              }
              this.oldPassingTime = newPassingTime
            }
          })
        }
      }, 5 * 1000)
    },
    // 来新车了
    newTrainConfirm() {
      this.newTrainVisible = true
      this.$confirm('是否跳转到最新一辆车查看?', '过车提醒', {
        confirmButtonText: this.waitTime ? `确定(${this.waitTime})` : '确定',
        cancelButtonText: '取消',
        type: 'warning',
        confirmButtonClass: 'auto-click-btn',
      }).then(() => {
        this.goToNewTrain()
      }).finally(() => {
        this.newTrainVisible = false
      })
      if (this.waitTime) this.autoNewTrain(this.waitTime)
    },
    // 倒计时自动切换到最新车次
    autoNewTrain(t) {
      if (this.newTrainVisible) {
        t--
        if (t >= 0) {
          setTimeout(() => {
            const confirmBtn = document.querySelector(".auto-click-btn")
            confirmBtn.innerHTML = `确定(${t})`
            this.autoNewTrain(t)
          }, 1000);
        } else {
          // 自动触发确定按钮点击事件
          const confirmBtn = document.querySelector(".auto-click-btn")
          confirmBtn.click()
          confirmBtn.innerHTML = `确定(${this.waitTime})`
        }
      }
    },
    // 添加小三角
    handleDomChange(idx) {
      this.removeTriangle()
      const arr = this.$refs.crud.$el.querySelectorAll('.el-table__row')
      const triangle = document.createRange().createContextualFragment(`<div class="triangle_trainList"></div>`)
      arr[idx].append(triangle);
    },
    removeTriangle() {
      const oldTriangle = document.getElementsByClassName('triangle_trainList')
      if (oldTriangle.length) oldTriangle[0].remove()
    },
  },
  beforeDestroy() {
    clearInterval(this.getNewTimer)
  }
}
</script>

<style scoped lang="scss">
.passing-search-list {
  position: relative;
  height: 49%;

  .add-container {
    position: absolute;
    top: 142px;
    z-index: 1;
  }

  .passing-search-direction {
    z-index: 1;
    margin-bottom: 10px;
    text-align: center;
  }

  ::v-deep .avue-crud .avue-crud__search {
    margin-bottom: 0;
  }
}

::v-deep .el-table .el-table__header-wrapper th {
  font-size: 20px;
  height: 45px;
  line-height: 0;

}
::v-deep .el-form .el-form-item {
  .el-form-item__label {
    font-weight: bold;
    padding: 0;
    font-size: 20px;
  }

  .el-input {
    font-size: 20px;
  }
}

::v-deep .el-radio-button__inner {
  font-size: 17px;
}

::v-deep .avue-form__menu {
  padding-right: 0;
  margin: 25px 0;
}

::v-deep .el-form-item__content {

  .el-button {
    color: #3CA2E0;
    background-color: #FFFFFF;
    border-width: 2px;
    border-color: #3CA2E0;
    border-radius: 20px;
    padding: 6px 10px;
  }

  .el-button:hover {
    background: #66b1ff;
    //border-color: #3CA2E0;
    color: #FFF;
  }

  .el-button span,
  .el-button {
    font-size: 16px;
  }

  .el-button+.el-button {
    margin-left: 5px;
  }
}

::v-deep .triangle-box {
  position: relative;
}

::v-deep .triangle_trainList {
  position: absolute;
  left: -3%;
  top: 5%;
  width: 0;
  height: 0;
  border-top: 22px solid transparent;
  border-left: 25px solid #2292d6;
  border-bottom: 22px solid transparent;
}
</style>
<style lang="scss">
$font-size: 20px;

.passing-search-select-popper {
  .el-select-dropdown__item {
    font-size: $font-size;
  }
}

.passing-search-time-popper {
  .el-picker-panel__body {
    .el-input--small .el-input__inner {
      font-size: $font-size;
    }

    .el-date-picker__header {

      .el-picker-panel__icon-btn,
      .el-date-picker__header-label {
        font-size: $font-size;
      }
    }

    .el-date-table {
      font-size: $font-size;
    }
  }
}
</style>
